import React, {useState, useEffect, useContext} from "react";
import "./AnalysisPlots.scss";
import {analysisPlotsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function AnalysisPlots() {
  const {isDark} = useContext(StyleContext);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const currentCategory = analysisPlotsSection.categories[currentCategoryIndex];
  const currentImages = currentCategory?.images || [];

  useEffect(() => {
    if (currentImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        if (prevIndex < currentImages.length - 1) {
          return prevIndex + 1;
        } else {
          // Move to next category
          setCurrentCategoryIndex((prevCatIndex) => {
            const nextCatIndex = (prevCatIndex + 1) % analysisPlotsSection.categories.length;
            return nextCatIndex;
          });
          return 0;
        }
      });
    }, analysisPlotsSection.slideInterval || 3000);

    return () => clearInterval(interval);
  }, [currentImages.length, currentCategoryIndex]);

  // Reset image index when category changes
  useEffect(() => {
    setCurrentImageIndex(0);
  }, [currentCategoryIndex]);

  if (!analysisPlotsSection.display) {
    return null;
  }

  const handleCategoryClick = (index) => {
    setCurrentCategoryIndex(index);
    setCurrentImageIndex(0);
  };

  return (
    <Fade bottom duration={500} distance="10px">
      <div className="main" id="analysis-plots">
        <div className="analysis-plots-main-div">
          <div className="analysis-plots-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading analysis-plots-heading"
                  : "heading analysis-plots-heading"
              }
            >
              {analysisPlotsSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle analysis-plots-subtitle"
                  : "subTitle analysis-plots-subtitle"
              }
            >
              {analysisPlotsSection.subtitle}
            </p>
          </div>

          {/* Category Tabs */}
          <div className="analysis-plots-categories">
            {analysisPlotsSection.categories.map((category, index) => (
              <button
                key={index}
                className={`analysis-plot-category-btn ${
                  currentCategoryIndex === index ? "active" : ""
                } ${isDark ? "dark-mode" : ""}`}
                onClick={() => handleCategoryClick(index)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Slideshow Container */}
          {currentImages.length > 0 ? (
            <div className="analysis-plots-slideshow">
              <div className="analysis-plot-image-container">
                <img
                  src={currentImages[currentImageIndex]}
                  alt={`${currentCategory.name} - Plot ${currentImageIndex + 1}`}
                  className="analysis-plot-image"
                />
              </div>
              <div className="analysis-plots-controls">
                <div className="analysis-plots-indicators">
                  {currentImages.map((_, index) => (
                    <span
                      key={index}
                      className={`indicator ${
                        currentImageIndex === index ? "active" : ""
                      }`}
                      onClick={() => setCurrentImageIndex(index)}
                    />
                  ))}
                </div>
                <div className="analysis-plots-info">
                  <span className="plot-counter">
                    {currentImageIndex + 1} / {currentImages.length}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="analysis-plots-placeholder">
              <p>Images will be added soon...</p>
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
}

